import { Box, Typography } from '@mui/material';

const FOOTER_HEIGHT = 40;

export default function AppFooter() {
  return (
    <Box
      component="footer"
      sx={{
        height: `${FOOTER_HEIGHT}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
        Copyright © 2026 SVP SPORTS
      </Typography>
    </Box>
  );
}

export { FOOTER_HEIGHT };
